<div class="grid grid-flow-col justify-between items-center mb-6">
  <h2 class="m-0">Insights</h2>

  <div class="flex items-center justify-center">
    <mat-spinner *ngIf="loadingStatistics && statistics" diameter="24" class="mr-4"></mat-spinner>
    <mat-form-field class="input__mini nopadding">
      <mat-select [(ngModel)]="selectedPeriod" (ngModelChange)="getSiteStatistics($event)" value="month">
        <mat-option *ngFor="let period of periods" [value]="period.value">{{ period.label }}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<div *ngIf="statistics; else loadingStatisticsTemplate" class="grid sm:grid-cols-2 xl:grid-cols-4 gap-4">
  <div
    *ngFor="let statistic of statistics.statistics"
    class="relative p-6 border border-smoke rounded-md border-sm flex flex-col">
    <h1>{{ statistic.value }}</h1>
    <span class="headline__secondary">{{ statistic.title }}</span>
    <mat-icon
      *ngIf="statistic.tooltip"
      [matTooltip]="statistic.tooltip"
      class="absolute top-1 right-1 scale-75 text-amber-400">
      info_outline
    </mat-icon>
  </div>
</div>

<ng-template #loadingStatisticsTemplate>
  <div class="flex justify-center">
    <mat-spinner diameter="24"></mat-spinner>
  </div>
</ng-template>
